export default __webpack_public_path__ + "static/media/public-bus-solution.b241d2a9.png";